import classNames from 'classnames';
import type { CSSProperties } from 'react';
import * as styles from './List.css';
import type { BulletedListElementProps, NumberedListElementProps } from './List.types';

export function BulletedListElement(props: BulletedListElementProps) {
  const { element, children, attributes, className } = props;
  const { width, maxWidth, mobile_hide, desktop_hide, customAttributes } = element.attrs || {};

  return (
    <ul
      {...customAttributes}
      className={classNames(
        className,
        {
          'mobile:hidden': mobile_hide,
          'desktop:hidden': desktop_hide,
        },
        styles.listElement,
        customAttributes?.className,
      )}
      style={
        {
          '--width': width,
          '--max-width': maxWidth,
        } as CSSProperties
      }
      {...attributes}
    >
      {children}
    </ul>
  );
}

export function NumberedListElement(props: NumberedListElementProps) {
  const { element, children, attributes, className } = props;
  const { width, maxWidth, mobile_hide, desktop_hide, customAttributes } = element.attrs || {};

  return (
    <ol
      {...customAttributes}
      className={classNames(
        className,
        {
          'mobile:hidden': mobile_hide,
          'desktop:hidden': desktop_hide,
        },
        styles.listElement,
        customAttributes?.className,
      )}
      style={
        {
          '--width': width,
          '--max-width': maxWidth,
        } as CSSProperties
      }
      {...attributes}
    >
      {children}
    </ol>
  );
}
